// src/i18n/locales/de/subscribe.ts

const subscribe = {
  title: 'Wähle deinen Plan',
  subtitle: 'Starte noch heute deine persönliche Ernährungsreise.',
  returningTitle: 'Abo reaktivieren',
  returningSubtitle: 'Mach weiter wo du aufgehört hast — deine Daten sind noch da.',

  billing: {
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    saveLabel: '{{percent}}% sparen',
  },

  plans: {
    basic: {
      name: 'BASIC',
      price: 'CHF 14.90',
      yearlyPrice: 'CHF 11.92',
      period: '/ Monat',
      yearlyNote: 'CHF 143.00 jährlich abgerechnet',
      cta: 'BASIC wählen',
      features: [
        '1× vollständiger 30-Tage-Plan',
        'Einfache Mahlzeitenbeschreibungen',
        'Kalorien & Zutaten pro Tag',
        'Berücksichtigt Allergien & Vorlieben',
      ],
      missing: [
        'Plan-Anpassungen',
        'Detaillierte Rezepte',
        'Einkaufsliste inklusive',
        'PDF-Export',
        'NutriBot-Chat',
        'Tägliche Coaching-E-Mails',
      ],
    },
    vip: {
      name: 'VIP',
      badge: 'Beliebteste Wahl',
      price: 'CHF 29.90',
      yearlyPrice: 'CHF 23.92',
      period: '/ Monat',
      yearlyNote: 'CHF 287.00 jährlich abgerechnet',
      cta: 'VIP wählen',
      features: [
        'Unbegrenzte 30-Tage-Pläne',
        'Jederzeit ändern & anpassen',
        'Detaillierte Schritt-für-Schritt-Rezepte',
        'Vollständige Einkaufs- & Rezeptliste',
        'PDF-Export für alle Pläne',
        'Dashboard mit Fortschrittsverfolgung',
        'Tägliche Motivations-E-Mails',
        '24/7 NutriBot-Chat-Assistent',
      ],
    },
  },

  verification: {
    checking: 'Zahlung wird überprüft...',
    success: 'Zahlung bestätigt! Du wirst weitergeleitet...',
    pending: 'Deine Zahlung ist bestätigt, die Aktivierung dauert noch einen Moment.',
    pendingHint: 'Klicke unten, um es erneut zu prüfen.',
    failed: 'Zahlung konnte nicht verifiziert werden. Falls du belastet wurdest, nutze den Aktualisieren-Button.',
    refreshButton: 'Aktivierungsstatus prüfen',
    syncing: 'Prüfe...',
  },

  guarantee: {
    money: '30-Tage-Geld-zurück-Garantie',
    cancel: 'Jederzeit kündbar',
    secure: 'Sichere Zahlung via Stripe',
  },

  cancelSuccess: 'Abo gekündigt. Zugang bis {{date}}.',
  errors: {
    checkoutFailed: 'Checkout konnte nicht gestartet werden. Bitte erneut versuchen.',
    portalFailed: 'Zahlungsportal konnte nicht geöffnet werden. Bitte erneut versuchen.',
    cancelFailed: 'Kündigung fehlgeschlagen. Bitte erneut versuchen.',
    syncFailed: 'Abo-Status konnte nicht überprüft werden. Bitte erneut versuchen.',
  },

  promo: {
    title: 'Hast du einen Promo-Code?',
    placeholder: 'Code eingeben (z.B. ANNA2025)',
    apply: 'Einlösen',
    applying: 'Prüfen...',
    remove: 'Entfernen',
    appliedLabel: '{{pct}}% Rabatt',
    errors: {
      invalid: 'Ungültiger oder inaktiver Promo-Code.',
      expired: 'Dieser Code ist abgelaufen.',
      notYet: 'Dieser Code ist noch nicht aktiv.',
      maxUses: 'Dieser Code hat die maximale Nutzungsanzahl erreicht.',
      alreadyUsed: 'Du hast diesen Code bereits verwendet.',
      failed: 'Code konnte nicht geprüft werden. Bitte erneut versuchen.',
    },
  },
};

export default subscribe;